import {onMounted, onUnmounted, Ref} from 'vue';

/**
 * Windows convention: Ctrl + Left Shift writes left-to-right, Ctrl + Right Shift writes right-to-left.
 * Applied on key up (like Windows) so shortcuts such as Ctrl+Shift+Z don't flip the direction.
 * The keys may be pressed and released in either order.
 */
export function useCtrlShiftDirection(containerRef: Ref<HTMLElement | undefined | null>) {
  let lastShiftCode: string | null = null;
  let pendingShiftCode: string | null = null;

  function isCtrlOrShift(e: KeyboardEvent) {
    return e.key === 'Shift' || e.key === 'Control';
  }

  function onKeydown(e: KeyboardEvent) {
    if (e.key === 'Shift')
      lastShiftCode = e.code;
    pendingShiftCode = isCtrlOrShift(e) && e.ctrlKey && e.shiftKey && !e.altKey && !e.metaKey ? lastShiftCode : null;
  }

  function onKeyup(e: KeyboardEvent) {
    const target = e.target;
    if (pendingShiftCode && isCtrlOrShift(e) && (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement))
      target.style.direction = pendingShiftCode === 'ShiftLeft' ? 'ltr' : 'rtl';
    pendingShiftCode = null;
  }

  let container: HTMLElement | undefined | null;

  onMounted(() => {
    container = containerRef.value;
    container?.addEventListener('keydown', onKeydown, true);
    container?.addEventListener('keyup', onKeyup, true);
  });

  onUnmounted(() => {
    container?.removeEventListener('keydown', onKeydown, true);
    container?.removeEventListener('keyup', onKeyup, true);
  });
}
